<template>
  <div ref="columnSetTooltip">
    <button
      class="tw-group tw-mx-4 tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4"
      :disabled="disabled"
      data-test-id="table-column-visibility-button"
      @click="toggleSetColumnTooltip"
    >
      <cl-icon-tabler-table :width="'24'" :height="'24'" :class="iconClass" />
    </button>
    <div
      v-if="isColumnSetTooltipOpen"
      id="set-rows-wrapper"
      class="tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-p-4 tw-pb-2 tw-shadow-md tw-transition-opacity"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { onClickOutside } from "@vueuse/core";

export type Props = {
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const isColumnSetTooltipOpen = ref(false);
const toggleSetColumnTooltip = (): void => {
  isColumnSetTooltipOpen.value = !isColumnSetTooltipOpen.value;
};
const iconClass = computed(() => {
  if (props.disabled) {
    return "tw-stroke-dorian-gray-200 tw-cursor-not-allowed";
  }
  if (isColumnSetTooltipOpen.value) {
    return "tw-stroke-secondary-500";
  }
  return "tw-stroke-dorian-gray-500 tw-transition-colors group-hover:tw-stroke-secondary-500";
});

const columnSetTooltip = ref(null);
onClickOutside(columnSetTooltip, () => {
  isColumnSetTooltipOpen.value = false;
});
</script>
